export default __webpack_public_path__ + "static/media/padron-clasik.ecb9f043.jpg";